import * as Yup from "yup";

const firstParentSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
});

const secondParentSchema = Yup.object().shape(
  {
    email: Yup.string()
      .email("Invalid email format")
      .when(["firstName", "lastName"], {
        is: (firstName: string, lastName: string) => firstName || lastName,
        then: (schema) => schema.required("Email is required"),
      }),
    firstName: Yup.string().when(["email", "lastName"], {
      is: (email: string, lastName: string) => email || lastName,
      then: (schema) => schema.required("First name is required"),
    }),
    lastName: Yup.string().when(["email", "firstName"], {
      is: (email: string, firstName: string) => email || firstName,
      then: (schema) => schema.required("Last name is required"),
    }),
  },
  [
    ["email", "firstName"],
    ["firstName", "lastName"],
    ["email", "lastName"],
  ]
);

export const schemaFamilyDetails = Yup.object().shape({
  // child: secondParentSchema,
  adoptiveParents: Yup.array().of(
    Yup.lazy((_value, options) => {
      const index = (options as any).path === "adoptiveParents[0]";
      return index ? firstParentSchema : secondParentSchema;
    }) as any
  ),
  biologicalParents: Yup.array().of(
    Yup.lazy((_value, options) => {
      const index = (options as any).path === "biologicalParents[0]";
      return index ? firstParentSchema : secondParentSchema;
    }) as any
  ),
});

export const formatDataForValidation = (data: any) => {
  return {
    child: {
      email: data.childEmail || "",
      firstName: data.childFirstName || "",
      lastName: data.childSecondName || "",
    },
    adoptiveParents: [
      {
        email: data.firstEmailAdoptiveFamily || "",
        firstName: data.firstFirstNameAdoptiveFamily || "",
        lastName: data.firstLastNameAdoptiveFamily || "",
      },
      {
        email: data.secondEmailAdoptiveFamily || "",
        firstName: data.secondFirstNameAdoptiveFamily || "",
        lastName: data.secondLastNameAdoptiveFamily || "",
      },
    ],
    biologicalParents: [
      {
        email: data.firstEmailBiologicFamily || "",
        firstName: data.firstFirstNameBiologicFamily || "",
        lastName: data.firstLastNameBiologicFamily || "",
      },
      {
        email: data.secondEmailBiologicFamily || "",
        firstName: data.secondFirstNameBiologicFamily || "",
        lastName: data.secondLastNameBiologicFamily || "",
      },
    ],
  };
};
